<div>
  <img *ngFor="let provId of providerIds" style="height: 20px; margin: 0 5px;" src="{{ 'assets/images/providers/' + idSources[provId] }}"  alt="">
</div>
